// extracted by mini-css-extract-plugin
module.exports = {"boxThree":"UICheckboxWewSquare_boxThree__23gVh","boxFour":"UICheckboxWewSquare_boxFour__epMO0"};